import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import RatingOptions from 'constants/rating-options';
import RatingScale from 'ui/RatingScale';

const Feedback = ({
  title,
  description,
  score,
  setScore,
  disabled = false,
  textVariantBody,
  bold,
}) => {
  return (
    <>
      {textVariantBody ? (
        <div className="w-100p d-f jc-sb mh-40 ai-c">
          <Text
            className="w-50p"
            variant={bold ? TEXT_VARIANTS.BODY_BOLD : TEXT_VARIANTS.BODY}
          >
            {title}
          </Text>
          <RatingScale
            disabled={disabled}
            ratingOptions={RatingOptions}
            score={score}
            setScore={setScore}
            setHoverCount={_ => {}}
            customClassName="CriteriaList-ratingScale d-f fw-w"
          />
        </div>
      ) : (
        <>
          <div className="d-f ai-c jc-sb minh-50">
            <div className="d-f fd-c w-75p">
              <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>{title}</Text>
              {description && (
                <Text variant={TEXT_VARIANTS.BODY}>{description}</Text>
              )}
            </div>
            <RatingScale
              disabled={disabled}
              ratingOptions={RatingOptions}
              score={score}
              setScore={setScore}
              setHoverCount={_ => {}}
              customClassName="CriteriaList-ratingScale d-f fw-w"
            />
          </div>
          <hr className="border-top-1 border-midnight-20 mt-24" />
        </>
      )}
    </>
  );
};

export default Feedback;
